<template>
  <div class="d-flex fd-column h-100 bg-white">
    <app-header :header-options="headerOptions" />
    <router-view />
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader';

export default {
  name: 'new-dashboard-layout',
  components: {
    AppHeader,
  },
  props: {
    headerOptions: Object,
  },
};
</script>
